// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Typography, Stack, Avatar } from '@mui/material';

// redux
import { useSelector, useDispatch } from 'react-redux';

// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// components
import { CustomAvatar } from '../../../components/custom-avatar';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    // padding: theme.spacing(2, 2.5),
    // borderRadius: Number(theme.shape.borderRadius) * 1.5,
    // backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
    const { user } = useAuthContext();

    //  get logged In  User Details 
    const loggedInUserDetails = useSelector(state => state.userdetails.userValue);
    const userRole = loggedInUserDetails?.Role;
    const userName = loggedInUserDetails?.UserName;

    return (
        <StyledRoot>
            {/* <CustomAvatar src={user?.photoURL} alt={user?.displayName} name={user?.displayName} />

      <Box sx={{ ml: 2, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap>
          {user?.displayName}
        </Typography>

        <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
          {user?.role}
        </Typography>
      </Box> */}
            <Stack direction='row' spacing={1} sx={{ mx: 2, my: 1 }}>
                <Avatar src={user?.photoURL} alt="photoURL" />

                <Stack direction='column' >
                <Typography variant="subtitle2" sx={{ color: 'common.black' }}>
                        {userName}
                </Typography>

                <Typography variant="caption" sx={{ color: 'common.black' }}>
                        {userRole}
                </Typography>
                </Stack>

            </Stack>

        </StyledRoot>
    );
}
